import { mapState } from 'vuex';
const lineAddFriendUrl = process.env.VUE_APP_LINE_ADD_FRIEND_URL;

export default {
  name: 'SignUpIndex',
  data(){
    return {
      status: 0,
      lineAddFriendUrl: lineAddFriendUrl
    }
  },
  mounted(){
  },
  methods:{
    backToOfficial() {
      const vm = this;
      window.location = vm.lineAddFriendUrl;
    }
  },
  computed: {
    ...mapState({
      pendingMessage: state => state.sign_up.pendingMessage,
    }),
  }
}
